import {
  Container,
  Dropdown,
  Form,
  Nav,
  Navbar,
  NavDropdown,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import NFCeConsultaCode from "./NFCe.Consulta.Code";
import NFCeModalPropriedadesView from "./Modal.Propriedades/NFCe.Modal.Propriedades.View";
import { getLabel } from "src/hook/Functions";
import { statusEnvioOptions } from "./NFCe.Consulta.Dto";
import moment from "moment";
import DatePicker from "react-datepicker";
import { NavDatePicker } from "src/componentes/NavDatePicker/NavDatePicker.Component";

const NFCeConsultaView = () => {
  const code = NFCeConsultaCode();

  return (
    <>
      <Container>
        <HeadPage headText="NFCe Consulta">
          <Dropdown.Item onClick={code.handleMenuClickDownloadXML}>
            Download XML
          </Dropdown.Item>
        </HeadPage>
        {!code.loading ? (
          <>
            <Navbar className="bg-body-tertiary justify-content-between">
              <Container>
                <Navbar.Collapse className="justify-content-end">
                  <Nav className="ms-auto">
                    <Form.Control
                      placeholder="Série"
                      className="bg-body-tertiary"
                      onChange={code.handleOnChange}
                      value={code.filtros.serie?.toString() || ""}
                    ></Form.Control>
                    <NavDropdown
                      onSelect={code.handleSelect}
                      id="dropdown-codigoStatusEnvio"
                      title={getLabel(
                        statusEnvioOptions,
                        code.filtros.codigoStatusEnvio,
                        "Status Envio",
                      )}
                    >
                      {statusEnvioOptions.map((option) => (
                        <NavDropdown.Item
                          key={option.value}
                          eventKey={option.value}
                          active={
                            code.filtros.codigoStatusEnvio === option.value
                          }
                        >
                          {option.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>

                    <DatePicker
                      locale="pt-BR"
                      selected={code.filtros.dataEmissaoInicial}
                      onChange={code.setDates}
                      startDate={code.filtros.dataEmissaoInicial}
                      endDate={code.filtros.dataEmissaoFinal}
                      selectsRange
                      dateFormat="dd/MM/yyyy"
                      withPortal
                      isClearable={true}
                      className="nav-datepicker"
                      title={code.datePickerTitle()}
                      customInput={<NavDatePicker />}
                    />
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>

            <Table responsive hover>
              <thead>
                <tr>
                  <th className="col-2">Número NFCe</th>
                  <th className="col-1">Série</th>
                  <th className="col-4">Status de Envio</th>
                  <th className="d-none d-sm-table-cell col-3">
                    Status Resposta Sefaz
                  </th>
                  <th className="col-2">Data Hora Emissão</th>
                </tr>
              </thead>
              <tbody>
                {code.data.map((item) => (
                  <tr
                    key={item.nfCeId}
                    onClick={code.handleClickPropriedades(item)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="col-2">{item.numeroNF}</td>
                    <td className="col-1">{item.serie}</td>
                    <td className="col-4">
                      {item.codigoStatusEnvio}-{item.descricaoStatusEnvio}
                    </td>
                    <td className="d-none d-sm-table-cell col-3">
                      {item.codigoStatusResposta}-{item.descricaoMotivoResposta}
                    </td>
                    <td className="col-2">
                      {moment(item.emissaoDataHora).format(
                        "DD/MM/YYYY HH:mm:ss",
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          <Placeholder animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Container>
      <NFCeModalPropriedadesView
        show={code.modalShowPropriedades}
        nfce={code.nfce}
        onCancel={code.onCancelModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
        onPrint={code.onPrintModalPropriedades}
        onDownloadXml={code.onDownloadXml}
        onFetchStatus={code.onFetchStatusModalPropriedades}
      />
    </>
  );
};

export default NFCeConsultaView;
